{
  "hub": {
    "title": "Collections | Trading Card Auction Categories — BidNova",
    "description": "Browse curated trading card auction collections by game, grade, character, language and format on BidNova Auctions.",
    "h1": "Collections",
    "intro": "Explore curated collections of live trading card auctions, grouped by game, grade, character, language and format.",
    "kinds": {
      "game": "By Game",
      "grade": "By Grade",
      "character": "By Character",
      "language": "By Language",
      "format": "By Format"
    }
  },
  "common": {
    "breadcrumbHome": "Home",
    "breadcrumbAuctions": "Auctions",
    "breadcrumbCollections": "Collections",
    "relatedLabel": "Related collections",
    "faqLabel": "Frequently asked questions",
    "browseAllCta": "See all matching listings",
    "emptyState": "No {label} auctions are live right now. New listings go up throughout the day — browse all auctions or check back shortly.",
    "whyBuyTitle": "Why buy on BidNova",
    "whyBuyBody": "BidNova is a UK-registered marketplace. Every listing is sold by a verified seller with a public rating, priced in GBP, and paid via Stripe. Funds are held until you confirm your order arrives as described.",
    "whyBuyPoint1": "Stripe-secured payments with buyer protection.",
    "whyBuyPoint2": "Verified UK sellers with public ratings and dispute resolution.",
    "whyBuyPoint3": "Prices in GBP — no surprise conversion fees.",
    "sellingTitle": "Selling {label}?",
    "sellingBody": "Approved sellers can list cards alongside singles and sealed product from one dashboard. Add photos, grading details and a starting price to get listed in minutes.",
    "sellCta": "Start selling"
  },
  "pokemonAuctions": {
    "title": "Pokémon Card Auctions — Live UK Bidding | BidNova",
    "description": "Bid on live UK auctions for graded and raw Pokémon cards. Stripe-secured payments, verified sellers, prices in GBP.",
    "intro": "Discover live UK auctions for Pokémon trading cards, from raw commons to PSA- and BGS-graded chase cards. Every listing is sold by a verified seller, priced in GBP and protected by Stripe-secured payments."
  },
  "onePieceAuctions": {
    "title": "One Piece Card Game Auctions | BidNova",
    "description": "Live UK auctions for One Piece TCG singles and sealed product, English and Japanese, raw and graded.",
    "intro": "Browse live auctions for the One Piece Card Game — English and Japanese singles, alt-art rares and sealed boxes, from raw copies to PSA, BGS and CGC graded slabs."
  },
  "yugiohAuctions": {
    "title": "Yu-Gi-Oh! Card Auctions | BidNova",
    "description": "Live UK Yu-Gi-Oh! card auctions — vintage and modern singles, graded and raw, English and Japanese.",
    "intro": "Shop live Yu-Gi-Oh! auctions covering vintage 1st Edition classics through to modern staples, with raw and professionally graded copies from verified UK sellers."
  },
  "psa10Cards": {
    "title": "PSA 10 Gem Mint Card Auctions | BidNova",
    "description": "Live auctions for PSA 10 Gem Mint trading cards across Pokémon, One Piece, sports and more.",
    "intro": "PSA 10 Gem Mint cards represent the pinnacle of centering, surface and corner condition. Browse live auctions across every major trading card game, each listing including the PSA certificate number for verification."
  },
  "bgsBlackLabel": {
    "title": "BGS Black Label 10 Auctions | BidNova",
    "description": "Live auctions for ultra-rare BGS Black Label 10 cards — perfect subgrades across the board.",
    "intro": "A BGS Black Label is the rarest designation Beckett awards — a perfect 10 in centering, corners, edges and surface. Browse live Black Label auctions from verified UK sellers."
  },
  "cgcPristine": {
    "q1": "What is CGC Pristine 10?",
    "a1": "Pristine 10 is CGC's top grade, reserved for cards with essentially flawless centering, surfaces, corners and edges.",
    "q2": "Is CGC Pristine 10 the same as PSA 10?",
    "a2": "They use different scales — CGC Pristine 10 is generally considered comparable to or stricter than a PSA 10.",
    "q3": "Which games are commonly CGC graded?",
    "a3": "CGC grades trading cards, manga, comics and sealed wax across Pokémon, One Piece, sports and more.",
    "q4": "Can I verify a CGC certificate?",
    "a4": "Yes, listings include the CGC certificate number for lookup on CGC's website."
  },
  "charizard": {
    "q1": "Why is Charizard so popular with collectors?",
    "a1": "Charizard has been a fan-favourite Pokémon since the original Base Set, driving strong long-term collector demand.",
    "q2": "Are graded Charizard cards available?",
    "a2": "Yes, PSA, BGS and CGC graded Charizard cards are listed alongside raw copies across many sets.",
    "q3": "Can I find Japanese Charizard cards?",
    "a3": "Yes, filter by card language to find Japanese print Charizard cards.",
    "q4": "Do you have vintage Base Set Charizard cards?",
    "a4": "Vintage and modern Charizard cards both appear — check the listing details for set and edition."
  },
  "pikachu": {
    "q1": "What makes Pikachu cards collectible?",
    "a1": "As Pokémon's mascot, Pikachu appears in countless promo, illustrator and special-edition prints prized by collectors.",
    "q2": "Are Pikachu Illustrator-style promos listed?",
    "a2": "Rare promo Pikachu cards appear occasionally — check current listings and set your search to be notified.",
    "q3": "Can I find graded Pikachu cards?",
    "a3": "Yes, PSA, BGS and CGC graded Pikachu cards are available alongside raw copies.",
    "q4": "Do you have Japanese Pikachu cards?",
    "a4": "Yes, filter by card language to find Japanese print Pikachu cards."
  },
  "umbreon": {
    "q1": "Why are Umbreon cards so sought after?",
    "a1": "Umbreon's Eeveelution artwork, especially Gold Star and VMAX Alt Art prints, is highly prized by collectors.",
    "q2": "Are graded Umbreon cards listed?",
    "a2": "Yes, PSA, BGS and CGC graded Umbreon cards appear alongside raw copies.",
    "q3": "Can I find Umbreon VMAX Alt Art?",
    "a3": "Alt Art and secret rare Umbreon cards appear when available — check current live listings.",
    "q4": "Do you have Japanese Umbreon prints?",
    "a4": "Yes, filter by card language to find Japanese print Umbreon cards."
  },
  "luffy": {
    "q1": "Which sets feature Luffy cards?",
    "a1": "Luffy appears across many One Piece Card Game sets as a Leader and Character card, including sought-after alt art prints.",
    "q2": "Are graded Luffy cards available?",
    "a2": "Yes, PSA, BGS and CGC graded Luffy cards appear alongside raw copies.",
    "q3": "Can I find Japanese Luffy cards?",
    "a3": "Yes, filter by card language to find Japanese print Luffy cards.",
    "q4": "Do you have manga-style Luffy cards?",
    "a4": "Manga-art parallel cards featuring Luffy occasionally appear — see our manga cards collection too."
  },
  "mangaCards": {
    "title": "Manga-Art Trading Card Auctions | BidNova",
    "description": "Live UK auctions for manga-style parallel trading cards, led by the One Piece Card Game.",
    "intro": "Manga cards are lower-pull-rate parallels using black-and-white manga artwork, most associated with the One Piece Card Game. Browse live manga-art auctions from verified UK sellers."
  },
  "japaneseCards": {
    "title": "Japanese Print Trading Card Auctions | BidNova",
    "description": "Live UK auctions for Japanese-print Pokémon, One Piece and Yu-Gi-Oh! cards, raw and graded.",
    "intro": "Japanese print cards are prized for premium cardstock, earlier releases and unique artwork. Browse live auctions for Japanese-language cards across every major trading card game."
  },
  "englishCards": {
    "title": "English Print Trading Card Auctions | BidNova",
    "description": "Live UK auctions for English-print trading cards across Pokémon, One Piece, Yu-Gi-Oh! and more.",
    "intro": "English print cards make up the majority of live listings on BidNova, spanning singles, sealed product and every major grading company. Browse the full range from verified UK sellers."
  },
  "pokemon": {
    "q1": "Are these Pokémon cards authentic?",
    "a1": "Every listing is sold by a verified UK seller and graded cards include certificate details from PSA, BGS or CGC where applicable.",
    "q2": "Can I buy raw (ungraded) Pokémon cards?",
    "a2": "Yes — both raw and professionally graded Pokémon cards are listed, filterable by grading company and grade.",
    "q3": "What payment methods are accepted?",
    "a3": "All auctions are priced in GBP and paid securely via Stripe, with funds held until you confirm delivery.",
    "q4": "Do you sell sealed Pokémon product?",
    "a4": "Yes, sealed booster boxes, packs and tins appear alongside singles — use the product type filter on the browse page."
  },
  "onePiece": {
    "q1": "What is the One Piece Card Game?",
    "a1": "A trading card game by Bandai based on the One Piece manga and anime, popular with collectors worldwide.",
    "q2": "Are Japanese and English One Piece cards both available?",
    "a2": "Yes — filter by card language to find English or Japanese print One Piece cards.",
    "q3": "Can I find Luffy cards specifically?",
    "a3": "Yes, see our dedicated Luffy collection for character-specific listings.",
    "q4": "Are graded One Piece cards available?",
    "a4": "Yes, PSA, BGS and CGC graded One Piece cards are listed alongside raw copies."
  },
  "yugioh": {
    "q1": "Do you have vintage Yu-Gi-Oh! cards?",
    "a1": "Yes, vintage and modern Yu-Gi-Oh! singles are listed, including 1st Edition and Limited Edition cards.",
    "q2": "Are Yu-Gi-Oh! cards graded?",
    "a2": "Many listings are professionally graded by PSA, BGS or CGC; raw cards are also available.",
    "q3": "Can I buy Japanese Yu-Gi-Oh! cards?",
    "a3": "Yes, filter by card language to find Japanese print Yu-Gi-Oh! cards.",
    "q4": "Is buy-it-now available?",
    "a4": "Many sellers offer a Buy Now price alongside live bidding — look for the Buy Now badge on listings."
  },
  "psa10": {
    "q1": "What does PSA 10 mean?",
    "a1": "PSA 10 (Gem Mint) is the highest grade awarded by Professional Sports Authenticator, indicating a virtually flawless card.",
    "q2": "Can I verify the PSA certificate?",
    "a2": "Yes, PSA-graded listings include the certificate number for independent verification on PSA's website.",
    "q3": "Which games have PSA 10 listings?",
    "a3": "PSA 10 cards span Pokémon, One Piece, Yu-Gi-Oh!, sports and more — use the browse filters to narrow by game.",
    "q4": "Are PSA 10 cards more expensive?",
    "a4": "Gem Mint condition typically commands a premium over lower grades due to scarcity and eye appeal."
  },
  "bgsBlack": {
    "q1": "What is a BGS Black Label?",
    "a1": "A Black Label is Beckett's rarest designation — a perfect 10 across all four subgrades (centering, corners, edges, surface).",
    "q2": "How rare are Black Label cards?",
    "a2": "Extremely rare — most graded populations show only a handful of Black Label examples per set.",
    "q3": "Can I verify a BGS certificate?",
    "a3": "Yes, BGS-graded listings include the cert number so you can verify subgrades on Beckett's site.",
    "q4": "Do Black Label cards sell for a premium?",
    "a4": "Yes, due to their rarity Black Label cards typically command significant premiums over standard BGS 10s."
  },
  "manga": {
    "q1": "What are manga cards?",
    "a1": "Manga cards are parallel prints using black-and-white or manga-style artwork instead of standard illustrations, popular in One Piece and other TCGs.",
    "q2": "Which games have manga-art cards?",
    "a2": "The One Piece Card Game is best known for manga rares, though other games occasionally issue similar parallels.",
    "q3": "Are manga cards graded?",
    "a3": "Yes, graded and raw manga cards both appear — filter by grading company to narrow results.",
    "q4": "Are manga cards rarer than standard prints?",
    "a4": "Manga rares are typically a lower-pull-rate parallel, making them more scarce than standard rarity prints."
  },
  "japanese": {
    "q1": "Why do collectors prefer Japanese print cards?",
    "a1": "Japanese cards are often printed on higher-quality cardstock, released earlier, and feature unique artwork variations.",
    "q2": "Are Japanese cards graded the same way?",
    "a2": "Yes, PSA, BGS and CGC all grade Japanese-language cards using the same scales as English cards.",
    "q3": "Which games have Japanese listings?",
    "a3": "Pokémon, One Piece and Yu-Gi-Oh! all have active Japanese print listings — use the game filters to browse.",
    "q4": "Do Japanese cards cost more than English?",
    "a4": "Pricing depends on rarity and condition rather than language alone, though some Japanese exclusives command premiums."
  },
  "english": {
    "q1": "Are most listings in English?",
    "a1": "English print cards make up the majority of listings across Pokémon, One Piece, Yu-Gi-Oh! and sports cards.",
    "q2": "Are English cards graded?",
    "a2": "Yes, PSA, BGS, CGC and other graders are represented, alongside raw ungraded English cards.",
    "q3": "Can I filter by set and edition?",
    "a3": "Yes, use the browse page filters for card set, edition (1st Edition/Unlimited) and finish (holo/reverse holo).",
    "q4": "Do you have English sealed product?",
    "a4": "Yes, English booster boxes and packs are listed alongside singles."
  }
}
